var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth29(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.64 205.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.7,1.24c9.37,0,14.06,0,21.34,5.21,7.28,5.21,16.89,10.41,15.16,23.42-1.73,13.01-5.19,39.04-9.51,46.85-4.32,7.81-2.97,36.44-2.97,36.44l-4.33,57.26-3.21,31.23s-4.2,10.41-9.99-13.01c-5.79-23.42-20.45-85.89-20.7-91.1-.25-5.21-3.57-26.03-8.75-36.44-5.18-10.41-6.77-44.25.01-49.45C12.54,6.45,19.32,1.24,28.7,1.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m32.14,24.67s-.25-5.21,4.32-7.81c4.56-2.6,9.25-2.6,13.94-2.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.49,19.46s11.59-2.6,13.94-2.6,2.34,0,4.44-5.21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.83,68.91s14.55,10.41,30.71,5.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth29);
export default __webpack_public_path__ + "static/media/tooth-29.a43f983d70e97f185e799261a35afa21.svg";
export { ForwardRef as ReactComponent };